import type { OptionKV } from "~styled/selector/Selector";

export enum EMotivoRechazoSiniestro {
  FaltaPago = "FaltaPago",
  DaniosNoCubiertos = "DaniosNoCubiertos",
  Fraude = "Fraude",
  Duplicado = "Duplicado",
}

export const FALTA_PAGO = EMotivoRechazoSiniestro.FaltaPago;
export const DANIOS_NO_CUBIERTOS = EMotivoRechazoSiniestro.DaniosNoCubiertos;
export const FRAUDE = EMotivoRechazoSiniestro.Fraude;
export const DUPLICADO = EMotivoRechazoSiniestro.Duplicado;

const motivoRechazoSiniestroOptions: Record<EMotivoRechazoSiniestro, string> = {
  [FALTA_PAGO]: "Falta de Pago",
  [DANIOS_NO_CUBIERTOS]: "Daños No Cubiertos",
  [FRAUDE]: "Fraude",
  [DUPLICADO]: "Duplicado",
};

const motivoRechazoSiniestroFilter: OptionKV<EMotivoRechazoSiniestro>[] = [
  { label: motivoRechazoSiniestroOptions[FALTA_PAGO], value: FALTA_PAGO },
  {
    label: motivoRechazoSiniestroOptions[DANIOS_NO_CUBIERTOS],
    value: DANIOS_NO_CUBIERTOS,
  },
  { label: motivoRechazoSiniestroOptions[FRAUDE], value: FRAUDE },
  { label: motivoRechazoSiniestroOptions[DUPLICADO], value: DUPLICADO },
];

export { motivoRechazoSiniestroOptions, motivoRechazoSiniestroFilter };
